import React from 'react';
import PropTypes from 'prop-types';

import './MapMarker.css';

const MapMarker = ({ lat, lng, imgSrc, primaryName, stackIndex = 0, onClick, unitsCount }) => {
	// Vertical stack offset: base is -50%, then move up by 130% for each subsequent marker
	const yOffset = -50 - (stackIndex * 130);

	return (
		<div
			style={{
				transform: `translate(-50%, ${yOffset}%)`,
				zIndex: 1000 - stackIndex
			}}
			className={`map-marker-container ${onClick ? 'clickable' : ''}`}
			lat={lat}
			lng={lng}
			onClick={onClick}
		>
			{stackIndex > 0 && <div className="marker-pole" />}
			<span className="marker-image-container">
				<img src={imgSrc} alt="Omnistream logo" />
				{unitsCount > 1 && <div className="units-count-badge">{unitsCount}</div>}
			</span>
			<span>{primaryName}</span>
		</div>
	);
};

MapMarker.propTypes = {
	lat: PropTypes.number.isRequired,
	lng: PropTypes.number.isRequired,
	imgSrc: PropTypes.string.isRequired,
	primaryName: PropTypes.string.isRequired
};

export default React.memo(MapMarker);
